export default __webpack_public_path__ + "static/media/devguide13.96c54175.md";